// src/components/admin/AdminStats.jsx
import React, { useEffect, useState } from "react";
import { useAdminApi } from "../../admin/adminApi";

const AdminStats = () => {
  const { getJson } = useAdminApi();
  const [stats, setStats] = useState(null);
  const [error, setError] = useState("");

  const load = async () => {
    try {
      setError("");
      const data = await getJson("/api/stats");
      setStats(data);
    } catch (e) {
      console.error("[ADMIN] Stats error:", e);
      setError("Failed to load stats");
    }
  };

  useEffect(() => {
    load();
    const id = setInterval(load, 5000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      style={{
        borderRadius: 16,
        padding: 12,
        background:
          "linear-gradient(135deg, rgba(15,23,42,0.96), rgba(15,23,42,0.99))",
        border: "1px solid rgba(148,163,184,0.35)",
      }}
    >
      <div
        style={{
          fontSize: 13,
          fontWeight: 600,
          marginBottom: 8,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <span>Server Stats</span>
        <button
          onClick={load}
          style={{
            fontSize: 11,
            borderRadius: 999,
            border: "1px solid rgba(148,163,184,0.6)",
            padding: "2px 8px",
            background: "rgba(15,23,42,0.9)",
            color: "#e5e7eb",
            cursor: "pointer",
          }}
        >
          Refresh
        </button>
      </div>

      {error && (
        <div style={{ fontSize: 11, color: "#f97373" }}>{error}</div>
      )}

      {!stats && !error && (
        <div style={{ fontSize: 12, color: "#9ca3af" }}>Loading…</div>
      )}

      {stats && (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
            gap: 8,
            fontSize: 12,
          }}
        >
          <StatBox label="Server time" value={stats.serverTime} />
          <StatBox
            label="Uptime (s)"
            value={Math.round(stats.uptimeSeconds)}
          />
          <StatBox label="Connected sockets" value={stats.connectedSockets} />
          <StatBox label="Active rooms" value={stats.rooms} />
          <StatBox label="Participants" value={stats.participants} />
        </div>
      )}
    </div>
  );
};

const StatBox = ({ label, value }) => (
  <div
    style={{
      padding: 8,
      borderRadius: 10,
      background: "rgba(15,23,42,0.9)",
      border: "1px solid rgba(55,65,81,0.9)",
    }}
  >
    <div style={{ fontSize: 10, color: "#9ca3af", marginBottom: 4 }}>
      {label}
    </div>
    <div style={{ fontSize: 13 }}>{String(value)}</div>
  </div>
);

export default AdminStats;
